import { RBAClient } from 'rba-client'
const moment = require('moment')
const client = RBAClient.getInstance(require('@/api/config'))

// initial state
const state = {
  records: [],
  search: '',
  orderby: '',
  order: '',
  page: 0,
  limit: 10,
  // checkoutStatus: null
  listing: {
    requestTimeout: null,
    requestLoading: false,
    columns: [
      'ref_id',
      'idens',
      'names',
      'status',
      'batch_scan_date',
      // 'emails',
      'tel',
      // 'fax',
      'create_date',
      'updated_date',
      'action'
    ],
    dateColumns: ['create_date', 'updated_date', 'batch_scan_date', 'acc_end_date'],
    options: {
      initFilters: [],
      initialPage: 1,
      perPage: 10,
      orderBy: {
        ascending: true,
        column: null
      },
      requestFunction (request) {
        this.requestKeys = request
        clearTimeout(this.requestTimeout)
        return new Promise((resolve, reject) => {
          this.requestTimeout = setTimeout(async () => {
            if (this.$store) {
              this.$store.commit('natural_person/peopleTable', { requestLoading: true })
            }
            Promise.all([
              // id search
              (() => {
                const idensToSearch = request.query.idens?.trim()
                // prevent empty search
                if (!idensToSearch) {
                  this.lastSearchIdens = null
                  this.lastSearchIdensResults = null
                  return null
                }
                // prevent duplicate search
                if (this.lastSearchIdens === idensToSearch) {
                  return this.lastSearchIdensResults
                }
                // search idens
                return client.identification.findWhere({
                  where: {
                    id_number: {
                      contains: idensToSearch
                    },
                    parent: {
                      '>': 0
                    }
                  },
                  limit: 500,
                  select: 'parent'
                })
                  .then((results) => {
                    // cache last search
                    this.lastSearchIdens = idensToSearch
                    this.lastSearchIdensResults = results
                    // return results
                    return results
                  })
              })(),
              // name search
              (() => {
                const nameToSearch = request.query.names?.trim()
                console.log(nameToSearch)
                // prevent empty search
                if (!nameToSearch) {
                  this.lastSearchNames = null
                  this.lastSearchNamesResults = null
                  return null
                }
                // prevent duplicate search
                if (this.lastSearchNames === nameToSearch) {
                  return this.lastSearchNamesResults
                }
                // search names
                return client.name.findWhere({
                  where: {
                    // partial sur & other
                    $OR: String(nameToSearch).split(' ')
                      .filter(Boolean)
                      .reduce((acc, _, key, all) => {
                        if (key !== all.length - 1) {
                          acc.push({
                            sur: { $Contains: all.slice(0, acc.length + 1).filter(Boolean).join(' ') },
                            other: { $Contains: all.slice(acc.length + 1).filter(Boolean).join(' ') }
                          })
                        }
                        return acc
                      }, [])
                      .reduce((acc, _, key, all) => {
                        // keep direct search
                        acc.push(all[key])
                        // allow reverse search
                        acc.push({
                          sur: all[key].other,
                          other: all[key].sur
                        })
                        return acc
                      }, [])
                      .concat([
                        // exact sur
                        { sur: { $Contains: nameToSearch } },
                        // exact other
                        { other: { $Contains: nameToSearch } }
                      ]),
                    person: { $NotEqual: null }
                  },
                  limit: 500,
                  select: 'person'
                })
                  .then((results) => {
                    // cache last search
                    this.lastSearchNames = nameToSearch
                    this.lastSearchNamesResults = results
                    // return results
                    return results
                  })
              })()
            ]).then(async (results) => {
              // combine results for idsearch and namesearch
              let ids = results.filter(Boolean).map((result) => {
                return result.data ? result.data.map((row) => {
                  return row.person ? row.person.id : (row.parent ? row.parent.id : null)
                }) : []
              })
              // reduce to duplicate ids
              ids = ids.length > 0 ? ids.reduce((x, y) => {
                return x.filter((x_row) => {
                  return y.includes(x_row)
                })
              }).filter(Boolean) : null

              const criteria = {
                // params: {
                where: (((query) => {
                  const _where = { and: [] }

                  if (ids) _where.id = { in: ids }
                  if (query.ref_id != null) _where.ref_id = { $Contains: query.ref_id }
                  if (query.status != null) _where.status = query.status
                  if (query.batch_scan_date) { // _where.batch_scan_date = query.batch_scan_date
                    _where.and = [
                      { batch_scan_date: { '>': moment(query.batch_scan_date.start).valueOf() } },
                      { batch_scan_date: { '<': moment(query.batch_scan_date.end).valueOf() } }
                    ]
                  }
                  // if (query.fax) _where.fax = { contains: query.fax }
                  if (query.tel) _where.tel = { contains: query.tel }
                  if (query.create_date) { // _where.create_date = query.create_date
                    _where.and = [
                      ..._where.and,
                      { create_date: { '>': moment(query.create_date.start).valueOf() } },
                      { create_date: { '<': moment(query.create_date.end).valueOf() } }
                    ]
                  }
                  if (query.updated_date) { // _where.updated_date = query.updated_date
                    _where.and = [
                      ..._where.and,
                      { updated_date: { '>': moment(query.updated_date.start).valueOf() } },
                      { updated_date: { '<': moment(query.updated_date.end).valueOf() } }
                    ]
                  }

                  if (_where.and.length === 0) delete _where.and

                  return _where
                })(request.query)), // Todo: parse where query
                // sort: `${request.byColumn} ${request.ascending}`, // Todo: parse sort query
                limit: request.limit,
                skip: request.limit * (request.page - 1),
                // sort: [
                // 	request.orderBy ? {
                // 		[request.orderBy]: request.ascending ? 'ASC' : 'DESC'
                // 	} : null
                // ].filter(Boolean)
                sort: request.orderBy ? `${request.orderBy} ${request.ascending ? 'ASC' : 'DESC'}` : 'create_date DESC',
                populate: 'names,idens'
                // }
              }

              Promise.all([
                client.individual.count(criteria),
                client.individual.findWhere(criteria)
              ])
                .then(([{ data: { count } }, { data }]) => {
                  resolve({ data, count })
                })
                .catch((error) => {
                  reject(error)
                })
            })
              .catch((error) => {
                reject(error)
              })
              .finally(() => {
                this.$store.commit('natural_person/peopleTable', { requestLoading: false })
              })
          }, (() => {
            // prevent multiple request
            if (request.query.idens?.trim() || request.query.names?.trim()) {
              return 500
            }
            return 0
          })())
        })
      },
      // responseAdapter (resp) {
      // 	// console.log('responseAdapter', resp);
      // 	return { data: resp.data[0], count: resp.data[1] };
      // },
      columnsClasses: {
        idens: 'col-xs-2',
        names: 'col-xs-2',
        status: 'col-xs-1',
        emails: 'col-xs-1',
        batch_scan_date: 'col-xs-1',
        tel: 'col-xs-1',
        fax: 'col-xs-1',
        create_date: 'col-xs-1',
        updated_date: 'col-xs-1',
        action: 'col-xs-1'
      },
      sortable: [
        // 'names',
        'ref_id',
        'status',
        'batch_scan_date',
        // 'emails',
        'tel',
        'fax',
        'create_date',
        'updated_date'
      ],
      filterable: [
        'ref_id',
        'idens',
        'names',
        'status',
        'batch_scan_date',
        // 'emails',
        'tel',
        // 'fax',
        'create_date',
        'updated_date'
      ],
      filterByColumn: true,
      dateColumns: ['create_date', 'updated_date', 'batch_scan_date', 'acc_end_date'],
      dateFormat: 'DD/MMM/YYYY'
      // see the options API
    }
  }
}

// getters
const getters = {
  options (state, getters, rootState, rootGetters) {
    const { i18n } = rootGetters
    const { initFilters, initialPage, perPage, orderBy, requestFunction, columnsClasses, sortable, filterable, filterByColumn, dateColumns, dateFormat } = state.listing.options

    return {
      initFilters,
      initialPage,
      perPage,
      orderBy,
      requestFunction,
      columnsClasses,
      sortable,
      headings: {
        ref_id: i18n.t('person.listing.table.ref_id.label'),
        idens: i18n.t('person.listing.table.idens.label'),
        names: i18n.t('person.listing.table.names.label'),
        status: i18n.t('person.details.form.status.label'),
        tel: i18n.t('person.details.form.tel.label'),
        batch_scan_date: i18n.t('person.listing.table.batch_scan_date.label'),
        create_date: i18n.t('person.listing.table.create_date.label'),
        updated_date: i18n.t('person.listing.table.updated_date.label'),
        action: i18n.t('listing.table.action.label')
      },
      filterable,
      filterByColumn,
      dateFormat,
      dateColumns,
      // datepickerOptions,
      // datepickerOptions: {
      //   // alwaysShowCalendars: true,
      //   ranges: {
      //     [i18n.t('listing.table.datepicker.today')]: [moment(), moment()],
      //     [i18n.t('listing.table.datepicker.yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      //     [i18n.t('listing.table.datepicker.last_n_days', { num_of_days: 7 })]: [moment().subtract(6, 'days'), moment()],
      //     [i18n.t('listing.table.datepicker.last_n_days', { num_of_days: 30 })]: [moment().subtract(29, 'days'), moment()],
      //     [i18n.t('listing.table.datepicker.this_month')]: [moment().startOf('month'), moment().endOf('month')],
      //     [i18n.t('listing.table.datepicker.last_month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      //   }
      // },
      texts: {
        count: i18n.t('listing.table.texts.count'),
        first: i18n.t('listing.table.texts.first'),
        last: i18n.t('listing.table.texts.last'),
        filter: i18n.t('listing.table.texts.filter'),
        filterPlaceholder: i18n.t('listing.table.texts.filterPlaceholder'),
        limit: i18n.t('listing.table.texts.limit'),
        page: i18n.t('listing.table.texts.page'),
        noResults: i18n.t('listing.table.texts.noResults'),
        noRequest: i18n.t('listing.table.texts.noRequest'),
        filterBy: i18n.t('listing.table.texts.filterBy'),
        loading: i18n.t('listing.table.texts.loading'),
        defaultOption: i18n.t('listing.table.texts.defaultOption'),
        columns: i18n.t('listing.table.texts.columns')
      },
      listColumns: {
        status: [
          {
            id: 0,
            text: i18n.t('person.details.form.status.options.inactive')// 'Inactive'
          },
          {
            id: 1,
            text: i18n.t('person.details.form.status.options.active') // 'Active',
            // hide:true
          }
        ]
      }
    }
  },
  people: state => {
    return state.records
  }
  // cartProducts: (state, getters, rootState) => {
  //   return state.items.map(({ id, quantity }) => {
  //     const product = rootState.products.all.find(product => product.id === id)
  //     return {
  //       title: product.title,
  //       price: product.price,
  //       quantity
  //     }
  //   })
  // },

  // cartTotalPrice: (state, getters) => {
  //   return getters.cartProducts.reduce((total, product) => {
  //     return total + product.price * product.quantity
  //   }, 0)
  // }
}

// actions
const actions = {
  findOne (context, payload) {
    console.log('findOne', payload, client.individual.findOne)
    // return API.get(`naturalperson_v2/${payload}`)
    return client.individual.findOne(payload)
  },
  async save (context, payload) {
    var person = JSON.parse(JSON.stringify(payload))
    const clearNull = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] == null) {
          delete obj[key]
        }
      })
      console.log(obj)
      return obj
    }
    const dateStringToInt = (date_string) => {
      date_string = date_string || 0 // default to 0
      return typeof date_string === 'string' && date_string && !isNaN(new Date(date_string)) ? new Date(date_string).getTime() : date_string
    }
    const handleChild = async (record, path, date_columns, endpoint) => {
      console.log(record, path, date_columns, endpoint)
      if (!record) {
        console.log('No record found')
        return false
      }
      if (record.is_deleted) {
        // TODO: remove
        if (!record.id) {
          return false
        } else {
          // var results = await API.delete(`${path}/${record.id}`);
          var results = await endpoint.destroy(record.id)
          if (results.status !== 200) { throw new Error(`DELETE FAILED: ${path}`) }
          return false
        }
      } else {
        // record.effect_date = dateStringToInt(record.effect_date);
        Object.keys(record).forEach((key) => {
          if (date_columns.indexOf(key) !== -1) {
            record[key] = dateStringToInt(record[key])
          }
        })
        if (!record.id) {
          // TODO: CREATE
          delete record.id
          // var results = await API.post(path, clearNull(record));
          results = await endpoint.create(clearNull(record))
          if (results.status !== 200) { throw new Error(`CREATE FAILED: ${path}`) }
          return results.data.id
        } else {
          // TODO: UPDATE
          results = await endpoint.update(record.id, clearNull(record)) // API.patch(`${path}/${record.id}`, clearNull(record));
          if (results.status !== 200) { throw new Error(`UPDATE FAILED: ${path}`) }
          return results.data.id
        }
      }
    }

    if (payload.ref_id) {
      const duplicate = await client.individual.findWhere({
        where: {
          id: {
            $NotEqual: payload.id ?? 0
          },
          ref_id: payload.ref_id
        }
      })
      if (duplicate.data.length > 0) {
        const error = new Error('Duplicate ref_id')
        error.response = {
          data: {
            code: 'E_UNIQUE'
          }
        }
        return Promise.reject(error)
      }
    }

    return new Promise((resolve, reject) => {
      try {
        Promise.all([
          Promise.all((person.names || []).map(x => handleChild(x, 'name', ['effect_date'], client.name))),
          Promise.all((person.addresses || []).map(x => handleChild(x, 'address', ['effect_date'], client.address))),
          Promise.all((person.emails || []).map(x => handleChild(x, 'email', ['effect_date'], client.email))),
          Promise.all((person.idens || []).map(x => handleChild(x, 'iden', ['effect_date', 'expiry_date'], client.identification))),
          // Promise.all((person.attachments || []).map(x => handleChild(x, 'attachment', ['effect_date', 'expiry_date'], client.attachment))),
          Promise.all((person.risk_assessments || []).map(x => handleChild(x, 'risk_assessment_history', [], client.risk_assessment_history)))
          // Promise.all((person.bank_infos || []).map(x => handleChild(x, 'bankinfo_v2', ['acc_open_date', 'acc_close_date']))),
        ]).then(([names_ids, address_ids, emails_ids, idens_ids, risk_assessments_ids]) => {
          person.names = names_ids.filter(Boolean)
          person.addresses = address_ids.filter(Boolean)
          person.emails = emails_ids.filter(Boolean)
          person.idens = idens_ids.filter(Boolean)
          // person.attachments = attachment_ids.filter(Boolean)
          delete person.attachments
          person.risk_assessments = risk_assessments_ids.filter(Boolean)
          // person.bank_infos = bank_infos_ids.filter(Boolean)
          delete person.bank_infos

          // date to int
          person.dob = dateStringToInt(person.dob)
          person.gender = person.gender || ''
          person.pob = person.pob || ''

          // when create new, status default to "Active"
          if (!person.id) { person.status = 1 }

          if (person.id) {
            // API.patch(`naturalperson_v2/${person.id}`, person)
            client.individual
              .update(person.id, person)
              .then(resolve)
              .catch(reject)
          } else {
            delete person.id
            // API.post(`naturalperson_v2`, person)
            client.individual
              .create(person)
              .then(resolve)
              .catch(reject)
          }
        })
          .catch((error) => {
            reject(error)
          })
      } catch (error) {
        reject(error)
      }
    })
  },
  remove (context, payload) {
    return client.individual.destroy(payload)
    // return API.delete(`naturalperson_v2/${payload}`)
  },
  similarIdentity (context, { person_id, id_type, id_number }) {
    return client.identification.findWhere({
      where: {
        type: id_type,
        id_number: {
          $Contains: id_number
        },
        parent: { $NotEqual: person_id }
      }
    })
  },
  similarName (context, { person_id, lang, name_type, sur, other }) {
    return client.name.findWhere({
      where: {
        $AND: [
          { person: { $NotEqual: person_id } },
          { person: { $GreaterThan: 0 } }
        ],
        lang,
        name_type,
        $OR: [
          sur ? { sur: { $Contains: sur } } : null,
          other ? { other: { $Contains: other } } : null
        ].filter(Boolean)
      },
      limit: 10
    })
  },
  async search (context, payload) {
    const query = payload.query
    const keywords = query.split(' ').map(word => word.trim()).filter(Boolean)
    return Promise.all([
      // search by idenity
      keywords.length > 0
        ? client.identification.findWhere({
          where: {
            $OR: keywords.map((x) => {
              return {
                id_number: {
                  contains: x
                }
              }
            }),
            parent: {
              '>': 0
            }
          },
          sort: 'id_number DESC',
          limit: 100 // limit to 100 related person
        })
        : { data: [] },
      // search by name
      keywords.length > 0
        ? client.name.findWhere({
          where: {
            $OR: [
              ...keywords.map((x) => {
                return {
                  sur: {
                    $Contains: x
                  }
                }
              }),
              ...keywords.map((x) => {
                return {
                  other: {
                    $Contains: x
                  }
                }
              })
            ],
            person: { $NotEqual: null }
          },
          sort: 'other DESC',
          limit: 100 // limit to 100 related person
        })
        : { data: [] },
      // search by ref_id
      keywords.length > 0
        ? client.individual.findWhere({
          where: {
            $OR: keywords.map((x) => {
              return {
                ref_id: {
                  $Contains: x
                }
              }
            })
          },
          select: 'ref_id,id'
        })
        : { data: [] }
    ]).then(async ([identitySearchResults, nameSearchResults, refIdSearchResults]) => {
      if (keywords.length > 0 && identitySearchResults.data.length === 0 && nameSearchResults.data.length === 0 && refIdSearchResults.data.length === 0) {
        return []
      }
      const identitySearchIds = identitySearchResults.data.map((row) => row.parent.id)
      const nameSearchIds = nameSearchResults.data.map((row) => row.person.id)
      const refIdSearchIds = refIdSearchResults.data.map((row) => row.id)
      const searchIds = [...identitySearchIds, ...nameSearchIds, ...refIdSearchIds]
      const uniqueSearchIds = [...new Set(searchIds)]
      return client.individual.findWhere({
        where: {
          ref_id: {
            '!=': ''
          },
          ...uniqueSearchIds.length > 0
            ? {
              id: {
                in: uniqueSearchIds
              }
            }
            : null
        },
        sort: 'create_date DESC',
        limit: 100 // limit to 100 related person
      })
        .then((results) => {
          results.data.map((row) => {
            row.idens_match = identitySearchResults.data.filter((iden) => iden.parent.id === row.id)
            row.names_match = nameSearchResults.data.filter((name) => name.person.id === row.id)
            row.ref_id_match = refIdSearchResults.data.filter((refId) => refId.id === row.id)
            return row
          })
          return results
        })
    })
  }
}

// mutations
const mutations = {
  'peopleTable/SET_DATA' (state, data) {
    console.log('peopleTable/SET_DATA', data)
  },
  'peopleTable/PAGINATION' (state, data) {
    console.log('peopleTable/PAGINATION', data)
  },
  'peopleTable/FILTER' (state, payload) {
    console.log('peopleTable/FILTER', payload)
  },
  'peopleTable/SORTED' (state, data) {
    console.log('peopleTable/SORTED', data)
  },
  'peopleTable/LOADING' (state, payload) {
    console.log('peopleTable/LOADING', payload)
    state.listing.options.initFilters = payload.query
    if (state.listing.options.initFilters.updated_date) {
      state.listing.options.initFilters.updated_date.start = moment(state.listing.options.initFilters.updated_date.start)
      state.listing.options.initFilters.updated_date.end = moment(state.listing.options.initFilters.updated_date.end)
    }
    if (state.listing.options.initFilters.create_date) {
      state.listing.options.initFilters.create_date.start = moment(state.listing.options.initFilters.create_date.start)
      state.listing.options.initFilters.create_date.end = moment(state.listing.options.initFilters.create_date.end)
    }
    if (state.listing.options.initFilters.batch_scan_date) {
      state.listing.options.initFilters.batch_scan_date.start = moment(state.listing.options.initFilters.batch_scan_date.start)
      state.listing.options.initFilters.batch_scan_date.end = moment(state.listing.options.initFilters.batch_scan_date.end)
    }
    state.listing.options.initialPage = payload.page
    state.listing.options.perPage = payload.limit
    state.listing.options.orderBy.ascending = payload.ascending
    state.listing.options.orderBy.column = payload.orderBy
    // state.listing.requestLoading = true
  },
  'peopleTable/LOADED' (state, data) {
    console.log('peopleTable/LOADED', data)
    state.listing.requestLoading = false
  },
  'peopleTable/LIMIT' (state, data) {
    console.log('peopleTable/LIMIT', data)
  },
  'peopleTable/ERROR' (state, data) {
    console.log('peopleTable/ERROR', data)
    state.listing.requestLoading = false
  },
  'peopleTable/ROW_CLICK' (state, data) {
    console.log('peopleTable/ROW_CLICK', data)
  },
  'peopleTable' (state, { requestLoading }) {
    state.listing.requestLoading = requestLoading === undefined ? state.listing.requestLoading : requestLoading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
